export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--Q.b5a3769e.png";